import dayjs from 'dayjs';
import 'dayjs/locale/de';
import 'dayjs/locale/de-at';
import 'dayjs/locale/de-ch';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/sv';
import 'dayjs/locale/nl';
import 'dayjs/locale/pt';

const locales = {
  'de-DE': 'de',
  'de-AT': 'de-at',
  'de-CH': 'de-ch',
  'en-GB': 'en-gb',
  'pt-PT': 'pt',
  es: 'es',
  fr: 'fr',
  it: 'it',
  pl: 'pl',
  se: 'sv',
  nl: 'nl',
};

const countryCode = locales[process.env.GATSBY_COUNTRY_CODE || 'de-DE'];

/**
 * Format date for blog posts
 *
 * @param {String} date
 * @param {String} [formatKey = DD MMMM YYYY]
 * @param {String} [locale = key in locales]
 *
 * @returns {String}
 */
function formatDate(date, formatKey = 'DD MMMM YYYY', locale = countryCode) {
  return dayjs(date).locale(locale).format(formatKey);
}

export default formatDate;
